<mat-card class="widget-card">
    <mat-card-header>
        <mat-card-title>Expenses by Category</mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-stat-card-content">
        <table mat-table [dataSource]="categoryStats">
            <ng-container matColumnDef="categoryName">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text"></th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.categoryName}}</td>
            </ng-container>
            <ng-container matColumnDef="12months">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text">12M</th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.last12MonthsValue | currency}}</td>
            </ng-container>
            <ng-container matColumnDef="ytd">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text">{{ytdLabel}}</th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.ytdValue | currency}}</td>
            </ng-container>
            <ng-container matColumnDef="avgPerMonth">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text">Avg</th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.avgPerMonth | currency}}</td>
            </ng-container>
            <ng-container matColumnDef="lastMonth">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text">{{lastMonthLabel}}</th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.lastMonthValue | currency}}</td>
            </ng-container>
            <ng-container matColumnDef="thisMonth">
                <th mat-header-cell *matHeaderCellDef class="table-stat-header-text">{{thisMonthLabel}}</th>
                <td mat-cell *matCellDef="let element" class="table-stat-cell-text">{{element.thisMonthValue | currency}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator showFirstLastButtons pageSize="10" aria-label="Select page of expense stats by category">
        </mat-paginator>
    </mat-card-content>
</mat-card>